import React from 'react';
import moment from 'moment';
import global from '../../../../common/utility/global';
import { FORMAT_2DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
const { Option } = Select;

export default function MetodoPago(props) {

    const handleChange = (property, identifier) => {
        props.onSetFieldsValue({
            [`arrIdCuenta[${identifier}]`]: { key: undefined },
        });
    };

    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Button
                                        type="danger"
                                        icon="delete"
                                        size={"small"}
                                        onClick={() => props.onRemove(value)}
                                    />
                                </div>
                            </span>
                        )
                    },



                    {
                        title: 'Fecha',
                        dataIndex: 'fechaPago',
                        key: 'fechaPago',
                        align: 'center',
                        width: '150px',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrFechaPago[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'idMetodoPago',
                        key: 'idMetodoPago',
                        width: '180px',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrIdTipoMetodoPago[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onChange'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Método de Pago"}
                                            optionFilterProp="children"
                                            onChange={() => handleChange(null, row.identifier)}

                                        >
                                            {
                                                props.metodosPagos.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                ))}
                                        </Select>
                                    )}
                                </Form.Item>

                            );
                        }
                    },
                    {
                        title: 'Cuenta',
                        dataIndex: 'idCuenta',
                        key: 'idCuenta',
                        width: '220px',
                        //className:'hide',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrIdCuenta[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onChange']
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Cuenta"}
                                            optionFilterProp="children"
                                        >
                                            {
                                                props.cuentas.map(item => (
                                                    <Option key={item.id} value={item.id} data={item}>{item.cuentaBancario}</Option>
                                                ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Nro Operacion',
                        dataIndex: 'referencia',
                        key: 'referencia',
                        align: 'center',
                        width: '180px',
                        // className:'hide',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrReferenciaPago[${row.identifier}]`, {
                                        initialValue: value

                                    })(
                                        <Input
                                            placeholder=""
                                            autoComplete="off"

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Monto',
                        dataIndex: 'montoPago',
                        key: 'montoPago',
                        width: '180px',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMontoPago[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Monto de pago debe ser mayor a 0"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Ingresar Monto de Pago"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                ]}
            />
        </div>
    );
}